var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28584 7.14281C2.11421 7.13981 1.94547 7.09817 1.79213 7.02101C1.6388 6.94385 1.50481 6.83314 1.40013 6.6971L0.142987 5.27424C0.0926514 5.21779 0.0540219 5.15192 0.0293381 5.08043C0.00465435 5.00894 -0.00559266 4.93326 -0.000808804 4.85778C0.00397505 4.7823 0.0236946 4.70853 0.0572066 4.64073C0.0907185 4.57293 0.137356 4.51245 0.194415 4.46281C0.308868 4.36361 0.45802 4.31391 0.609099 4.32463C0.760178 4.33534 0.900823 4.4056 1.00013 4.51996L2.17727 5.85138C2.18874 5.86788 2.20417 5.88124 2.22214 5.89022C2.24011 5.89921 2.26005 5.90354 2.28013 5.90281C2.29959 5.90329 2.31891 5.89943 2.3367 5.89152C2.35449 5.88362 2.3703 5.87186 2.38299 5.8571L7.01727 1.03424C7.1245 0.937806 7.26423 0.885483 7.40843 0.887767C7.55263 0.890052 7.69063 0.946775 7.79475 1.04656C7.89888 1.14634 7.96142 1.28181 7.96983 1.42578C7.97825 1.56975 7.93192 1.71158 7.84013 1.82281L3.15442 6.75424C3.04756 6.87942 2.91418 6.97924 2.76394 7.04646C2.6137 7.11367 2.45039 7.14658 2.28584 7.14281V7.14281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.2573a05f7d703c312e968390cbf9e3ba.svg";
export { ForwardRef as ReactComponent };